import { render, staticRenderFns } from "./PcarePassword.vue?vue&type=template&id=6a181c82&scoped=true"
import script from "./PcarePassword.vue?vue&type=script&lang=js"
export * from "./PcarePassword.vue?vue&type=script&lang=js"
import style0 from "./PcarePassword.vue?vue&type=style&index=0&id=6a181c82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a181c82",
  null
  
)

export default component.exports